import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import SuccessIcon from 'assets/success.svg?react';

type PhotoSubmissionSuccessProps = {
  geoEventId?: number;
};

export const PhotoSubmissionSuccess = (
  props: PhotoSubmissionSuccessProps,
): JSX.Element => {
  const { geoEventId } = props;
  const { t } = useTranslation();
  const history = useHistory();

  const goBack = (): void => {
    if (geoEventId) {
      history.replace(`/i/${geoEventId}`);
    } else {
      history.replace('/');
    }
  };

  return (
    <Container
      maxWidth="md"
      sx={{
        pt: 7,
        paddingBottom: 'max(env(safe-area-inset-bottom), 16px)',
        overflowY: 'auto',
      }}
    >
      <Stack spacing={2}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SuccessIcon />
        </Box>

        <Typography variant="h2" align="center">
          {t('photoSubmission.success.title')}
        </Typography>

        <Typography>{t('photoSubmission.success.description1')}</Typography>

        <Typography>{t('photoSubmission.success.description2')}</Typography>

        <Button fullWidth size="large" onClick={goBack} color="neutral">
          {t('photoSubmission.success.button')}
        </Button>
      </Stack>
    </Container>
  );
};
